import { getSupabase } from "@/lib/supabase";
import { useCallback, useState } from "react";

const TTL_SECONDS = 60;

/**
 * Returns a callback that produces a fresh signed URL for a path inside the
 * `compliance` private bucket. We never store signed URLs in component state
 * for long — they expire after 60s. The caller opens them immediately.
 */
export function useSignedUrl(bucket = "compliance") {
  const [pending, setPending] = useState(false);

  const fetchUrl = useCallback(
    async (path: string): Promise<{ url: string | null; error: string | null }> => {
      setPending(true);
      try {
        const supabase = getSupabase();
        const { data, error } = await supabase.storage
          .from(bucket)
          .createSignedUrl(path, TTL_SECONDS);
        if (error) return { url: null, error: error.message };
        return { url: data?.signedUrl ?? null, error: null };
      } finally {
        setPending(false);
      }
    },
    [bucket],
  );

  return { fetchUrl, pending };
}
